import { IFailedRequest } from '../errorHandler'

// ignores the error handling behaviour in defaultHandler and just throws the error, so it can be handeled in the consuming code.
function onlyThrowErrorHandler(failedRequest: IFailedRequest) {
  throw failedRequest.error
}

export default onlyThrowErrorHandler
